export   const getRandomColor = () => {
    const colors = ["#9E6DDD", "#4E9CF8", "#EA7774", "#57D175", "#D8AC04"];
    const index=Math.floor(Math.random() * colors.length)
    return colors[index];
  };